import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';


function HoursForm({clinicHours,updateHours,toogleEditing}) {
    const { control, handleSubmit, watch } = useForm({
        defaultValues: {
          clinicHours: clinicHours
        }
      });
    
      const watchedValues = watch();
    
      const onSubmit = (data) => {
        updateHours(data.clinicHours);
        toogleEditing();
      };
    
      const getTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
          for (let minute = 0; minute < 60; minute += 30) {
            const h = hour % 12 === 0 ? 12 : hour % 12;
            const period = hour < 12 ? 'AM' : 'PM';
            const m = minute === 0 ? '00' : minute;
            options.push(`${h}:${m} ${period}`);
          }
        }
        return options;
      };
    
      const timeOptions = getTimeOptions();
  return (
    <>
     <form onSubmit={handleSubmit(onSubmit)}>
          {clinicHours.map((day, index) => (
            <div className="mb-4 p-4 border rounded" key={index}>
              <div className="d-flex align-items-center mb-3">
                <div className="form-check">
                  <Controller
                    name={`clinicHours[${index}].status`}
                    control={control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={field.value === 1}
                        onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                        id={`day-${index}`}
                      />
                    )}
                  />
                </div>
                <label className="form-check-label ms-2 fw-bold" htmlFor={`day-${index}`}>
                  {day.day}
                </label>
              </div>

              {watchedValues?.clinicHours?.[index]?.status === 1 && (
                <div className="row g-3">
                  <div className="col-md-5">
                    <label className="form-label">Start Time</label>
                    <Controller
                      name={`clinicHours[${index}].start`}
                      control={control}
                      render={({ field }) => (
                        <select className="form-select" {...field}>
                          <option value="">Select time</option>
                          {timeOptions.map((time) => (
                            <option key={time} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                  </div>
                  <div className="col-md-5">
                    <label className="form-label">End Time</label>
                    <Controller
                      name={`clinicHours[${index}].end`}
                      control={control}
                      render={({ field }) => (
                        <select className="form-select" {...field}>
                          <option value="">Select time</option>
                          {timeOptions.map((time) => (
                            <option key={time} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <label className="form-label">Notes</label>
                    <Controller
                      name={`clinicHours[${index}].note`}
                      control={control}
                      render={({ field }) => (
                        <textarea
                          className="form-control"
                          rows="2"
                          placeholder="Any special instructions"
                          {...field}
                          value={field.value || ''}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
          ))}

          <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
            <button type="submit" className="btn btn-primary">
              Save Changes
            </button>
          </div>
        </form>
        {/*
    <form onSubmit={handleSubmit(onSubmit)}>
         {clinicHours.map((day,index)=>{
            return (
                <div className="d-flex mb-6" key={index}>
                
                    <div className="form-check">
                        <input type="checkbox" {...register(`day.status`)} className="form-check-input" />
                    </div>
                    <div className='d-flex flex-column'>
                        <input type="text" {...register(`day.day`)} className="form-control form-control-sm" />
                        <div className="d-flex mt-3">
                            <div className="form-group me-3">
                                <label htmlFor="" className='form-label'>Start</label>
                                <input type="text" {...register(`clinicHours[${index}].start`)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                            <label htmlFor="" className='form-label'>End</label>
                                <input type="text" {...register(`clinicHours[${index}].end`)} className="form-control form-control-sm" />
                            </div>
                        </div>
                        
                        <textarea {...register(`clinicHours[${index}].note`)} className="form-control form-control-sm mt-3" placeholder='Note' rows="3"></textarea>
                    </div>
                </div>
            )
         })}
    </form>
        */}
    </>
  )
}

export default HoursForm